import ButtonSecondary from "shared/Button/ButtonSecondary";
import Badge from "shared/Badge/Badge";
import NcImage from "shared/NcImage/NcImage";
import useProfileBookingCard from "hooks/useProfileBookingCard";
import { useTranslation } from "react-i18next";

export default function ProfileBookingCard({ size = "default", className = "", data = {}, allowUpload = false, minHourBeforeCancel = 48, credentials, _onCancelBooking }: any) {
  const { promotion_type_id, venue_image_url, venue_name_tc, venue_name_en, venue_booking_id, gross_amount, net_amount, contact_email, contact_phone, remarks } = data as any;

  const { inputRef, start, end, formatted_credentials, isBookingExpired, totalHours, isEnableCancel, isUploadingPayment, isPaymentCompleted, _onPaymentUpload } = useProfileBookingCard({
    data,
    credentials,
    minHourBeforeCancel,
  });

  const { t } = useTranslation();

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform shadow-xl transition-shadow ${className}`}
      data-nc-id="StayCard">
      <div className="relative w-full">
        <div className={`${venue_image_url} relative group overflow-hidden`}>
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              <li className="glide__slide">
                <NcImage src={venue_image_url} />
              </li>
            </ul>
          </div>
        </div>

        {/* <SaleOffBadge desc="Approved" className="absolute right-3 top-3" /> */}
      </div>
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <span className="text-sm text-neutral-500 dark:text-neutral-400">#{venue_booking_id}</span>
          <div className=" items-center space-x-2">
            {/* {isAds && <Badge name="ADS" color="green" />} */}
            <h2 className={` font-medium capitalize ${size === "default" ? "text-lg" : "text-base"}`}>
              <span className="line-clamp-1">{venue_name_tc}</span>
              <span className="text-sm text-neutral-500 dark:text-neutral-400">{venue_name_en}</span>
            </h2>
          </div>
          {promotion_type_id && (
            <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2 mt-3 mb-3">
              <Badge color="blue" name={t("profile_card_point_used")} />
            </div>
          )}
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <i className={`text-xl text-neutral-500 las la-calendar`}></i>
            <span className="">{start.format("YYYY/MM/DD HH:mm") + " - " + end.format("YYYY/MM/DD HH:mm")}</span>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <i className={`text-xl text-neutral-500 las la-clock`}></i>
            <span className="">{totalHours}</span>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <i className={`text-xl text-neutral-500 las la-envelope`}></i>
            <span className="">{contact_email === "null" ? "--" : contact_email}</span>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <i className={`text-xl text-neutral-500 las la-phone-alt`}></i>
            <span className="">{contact_phone === "null" ? "--" : contact_phone}</span>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <i className={`text-xl text-neutral-500 las la-comment`}></i>
            <span className="">{remarks === "null" ? "--" : remarks}</span>
          </div>
        </div>
        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div>
        {formatted_credentials?.enableDisplay && (
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            <i className={`text-xl text-neutral-500 las ${formatted_credentials?.icon}`}></i>
            <span className="">{formatted_credentials?.message}</span>
          </div>
        )}

        <div className="flex justify-between items-center">
          {gross_amount != net_amount ? (
            <div>
              <span className="mt-1.5 text-lg text-neutral-600 mr-1">{`HKD $${Number(net_amount).toFixed(1)}`}</span>
              <span className="mt-1.5 text-sm text-neutral-400 line-through">{gross_amount ? `HKD $${gross_amount}` : "--"}</span>
            </div>
          ) : (
            <span className="mt-1.5 text-lg text-neutral-600">{gross_amount ? `HKD $${gross_amount}` : "--"}</span>
          )}
          {/* 
          {true && (

          )} */}

          {!isPaymentCompleted && allowUpload ? (
            <div>
              {isEnableCancel && (
                <a
                  className="mr-5 text-sm font-semibold text-neutral-500 dark:text-neutral-40"
                  style={{ color: "red" }}
                  onClick={() => {
                    _onCancelBooking(venue_booking_id);
                  }}>
                  取消預約
                </a>
              )}
              <ButtonSecondary loading={isUploadingPayment} disabled={isUploadingPayment} onClick={() => inputRef.current.click()}>
                {t("profile_upload_receipt")}
              </ButtonSecondary>
              <input onChange={_onPaymentUpload} accept="image/png, image/gif, image/jpeg" multiple={false} ref={inputRef} type="file" hidden />
            </div>
          ) : (
            <div>
              {isEnableCancel && (
                <a
                  className="mr-5 text-sm font-semibold text-neutral-500 dark:text-neutral-40"
                  style={{ color: "red" }}
                  onClick={() => {
                    _onCancelBooking(venue_booking_id);
                  }}>
                  取消預約
                </a>
              )}
              <span className="text-base font-semibold text-neutral-500 dark:text-neutral-400">{isBookingExpired ? t("expired") : allowUpload ? t("profile_pending_approval") : t("soon")}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
